enum DirectoryNames {
	JOB_EHS = 'Job EHS',
	WORK_ORDER_EHS = 'Work Order EHS',
	WORK_ORDER_INFO = 'Work Order Info',
	JOB_INFO = 'Job Info',
	WAGE_INFO = 'Wage Info'
}

export default DirectoryNames;
